import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GetApp from "../components/GetApp";
import { Helmet } from "react-helmet";

const Terms = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Terms of Service</title>
        <link rel="canonical" href="https://boque.me/terms" />
        <meta
          name="description"
          content="Terms of use for the boque app, website and associated services. These General Conditions of Use apply to all services provided by
          Boque. Boque owns and operates a Site and App operating in Uganda, Kenya, Rwanda and Tanzania."
        />
      </Helmet>
      <div
        className="header-small"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col>
              <h1>Terms and Conditions</h1>
              <p className="mt-3 fs-4">Last Updated: 29th January 2025</p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="mt-3">
          <Col sm={12}>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using Boque.me ("Website"), Boque mobile
              applications ("Apps"), or any services provided through them
              (collectively "Service"), you agree to be bound by these Terms and
              Conditions ("Terms").
            </p>

            <h2>2. Service Description</h2>
            <p>Boque operates a two-sided marketplace connecting:</p>
            <ul>
              <li>
                <strong>Clients:</strong> Individuals requesting beauty/wellness
                services
              </li>
              <li>
                <strong>Service Providers:</strong> Licensed professionals
                offering manicure, pedicure, massage, and related services
              </li>
            </ul>

            <h2>3. User Eligibility</h2>
            <ul>
              <li>Must be at least 18 years old</li>
              <li>
                Service Providers must maintain valid professional licenses
              </li>
              <li>
                Users are responsible for compliance with local regulations
              </li>
            </ul>

            <h2>4. Account Registration</h2>
            <ul>
              <li>
                Separate accounts required for Client and Service Provider roles
              </li>
              <li>Must provide accurate, current, and complete information</li>
              <li>You are responsible for maintaining account security</li>
            </ul>

            <h2>5. Service Terms</h2>
            <p>
              <strong>For Clients:</strong>
            </p>
            <ul>
              <li>Responsible for accurate service requests</li>
              <li>Must provide safe working environment for providers</li>
              <li>Payment obligations are final except as specified</li>
            </ul>

            <p>
              <strong>For Service Providers:</strong>
            </p>
            <ul>
              <li>Must maintain proper insurance and certifications</li>
              <li>Responsible for quality of services rendered</li>
              <li>Must honor scheduled appointments</li>
            </ul>

            <h2>6. Payments and Fees</h2>
            <ul>
              <li>Boque charges a 15-20% service fee on transactions</li>
              <li>
                All payments processed through secure third-party gateways
              </li>
              <li>
                Refund requests must be submitted within 24 hours of service
              </li>
            </ul>

            <h2>7. Content Ownership</h2>
            <ul>
              <li>
                Users retain ownership of uploaded content (photos, reviews)
              </li>
              <li>
                Grant Boque a worldwide license to use content for service
                operation
              </li>
              <li>Prohibit uploading illegal or infringing material</li>
            </ul>

            <h2>8. Prohibited Activities</h2>
            <ul>
              <li>Circumventing in-app payment system</li>
              <li>Discriminatory behavior or harassment</li>
              <li>Commercial use of client/provider contact information</li>
              <li>Reverse engineering or unauthorized access</li>
            </ul>

            <h2>9. Limitation of Liability</h2>
            <p>Boque is not liable for:</p>
            <ul>
              <li>Quality or safety of third-party services</li>
              <li>Direct/indirect damages from service use</li>
              <li>Disputes between users</li>
            </ul>

            <h2>10. Termination</h2>
            <ul>
              <li>We may suspend accounts violating these Terms</li>
              <li>Users may delete accounts at any time</li>
              <li>Termination doesn't relieve outstanding payments</li>
            </ul>

            <h2>11. Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of [COMPANY LOCATION],
              without regard to its conflict of law provisions.
            </p>

            <h2>12. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Continued
              use after changes constitutes acceptance. Material changes will be
              notified via:
            </p>
            <ul>
              <li>In-app notifications</li>
              <li>Registered email alerts</li>
              <li>Website banner notices</li>
            </ul>

            <h2>13. Contact Information</h2>
            <p>
              For questions about these Terms:
              <br />
              Boque Ltd.
              <br />
              [ADDRESS]
              <br />
              Email: <a href="mailto:legal@boque.me">legal@boque.me</a>
              <br />
              Phone: [PHONE]
            </p>
          </Col>
        </Row>
      </Container>
      <GetApp />
    </>
  );
};

export default Terms;
